import { NavLink } from 'react-router-dom';
import { ALL_CATEGORIES } from '../../constants/blogCategories';
import { toSlug } from '../../utils/slug';

/**
 * Horizontal category strip shown on the listing pages.
 *
 * Real <a href> links (not filter buttons), because every category is a
 * distinct indexable URL and crawlers need something to follow. On narrow
 * screens the row scrolls horizontally rather than wrapping into a tall block.
 */
function CategoryNav({ includeAll = true, ariaLabel = 'Article categories' }) {
  return (
    <nav className="category-nav" aria-label={ariaLabel}>
      <ul className="category-nav-list">
        {includeAll && (
          <li>
            <NavLink to="/blogs" end className="chip chip-link">
              All
            </NavLink>
          </li>
        )}
        {ALL_CATEGORIES.map((c) => (
          <li key={c}>
            <NavLink to={`/category/${toSlug(c)}`} className="chip chip-link">
              {c}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default CategoryNav;
